<template>
    <div class="w-full mb-4">
        <div class="error" v-if="errors" v-for="error in errors">
            {{ error }}
        </div>

        <label for="forSelectType" class="form-label-class">Type</label>
        <select v-model="modelType" id="forSelectType" name="type" class="form-control form-control-sm form-control-fixed form-input-modal">
            <option v-for="element in types" :value="element.value">{{ element.label }}</option>
        </select>

        <div v-if="hasTags()" class="flex flex-wrap items-center mt-4 border">
            <div class="w-full bg-gray-super-100 border-b px-2 py-1">
                <h5>Select Category(s):</h5>
            </div>
            <div class="w-full py-1 px-2">
                <div v-for="tag in videoTags" :key="tag.id">
                    <label :for="`tag-${tag.category_id}`" class="text-xs">
                        <input :checked="getChecked(tag)" :id="`tag-${tag.category_id}`" name="categories[]" :type="inputType" :value="tag.category_id" class="form-control mb-1 mr-1">
                        <span class="inline-block ml-1">{{ tag.name }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    initialType: String,
    initialCategories: Array,
    types: {
        type: Array,
        required: true
    },
    tags: {
        type: Object,
        required: true
    },
    errors: Array
});

const modelType = ref(props.initialType || 'training');

const videoTags = computed(() => {
    let computedType = 'training';
    switch (modelType.value) {
        case 'binary-vol-2':
        case 'binary':
            computedType = 'binary';
            break;
        case 'pas':
            computedType = 'pas';
            break;
    }
    return props.tags[computedType];
});

const inputType = computed(() => {
    return modelType.value === 'training' ? 'checkbox' : 'radio';
});

const hasTags = () => {
    return ['training', 'binary', 'binary-vol-2'].includes(modelType.value);
};

const getChecked = (tag) => {
    const found = props.initialCategories.find((category) => {
        return category.name === tag.name && category.type === tag.type;
    });
    return found ? true : false;
};
</script>
